/* eslint-disable max-len */
import React,{useState,useEffect,useCallback,useContext} from 'react'
import Checkbox from 'react-custom-checkbox'
import Modal from 'react-modal'
import { distributorService } from '../../service/distributor.service'
import './style.css'
import * as Icon from "react-icons/fi";
import * as Check from "react-icons/go";
import CreateModal from './CreateModal'
import { ShimmerBadge,ShimmerCircularImage } from 'react-shimmer-effects'
import ThreeDotsLoader from '../LoadingDots'

export default function WishlistHandler({
    show,
    setShow,
    setmodalType,
    handleAddToWishList,
    wishlistLoader,
    handleErrorMessage,
    selectedItem,
    handleSuccessMessage,
    FromCart}) {
    const [list, setlist] = useState([]);
    const [selected, setselected] = useState([]);
    const [isCreate, setisCreate] = useState(false)
    const [loading, setloading] = useState(true);
    const [PreveiouslyExist, setPreveiouslyExist] = useState(false)
    const handlefetch = useCallback(
        () => {
            distributorService.ListwhishList().then((item)=>{
                if(!item.error && item?.data?.success_status){
                    setlist(item.data.data)
                    const newList=[];
                    item.data.data.map((val)=>{
                        if(val.item_ids.includes(String(selectedItem?.INVENTORY_ITEM_ID))){
                            newList.push(val)
                        }
                    })
                    if(newList.length>0){
                        setPreveiouslyExist(true)
                    }
                    setselected(newList)
                }
                setloading(false)
            })
        },
        [],
    )
    useEffect(() => {
        handlefetch()
    }, [handlefetch]);
    const handleSelect=(item)=>{
        const copy =[...selected];
        const idx = copy.map((val)=>val.collection_id).indexOf(item.collection_id);
        if(idx === -1){
            copy.push(item)
        }else{
            copy.splice(idx,1)
        }
        setselected(copy)
    }
    const handleCreate = async(name,type)=>{
        let message=''
        const payload = {
            "collection_name":name
        }
        let crud;
        if(type==='create'){
            message='created';
            crud = await distributorService.createWishlist(payload);
        }
        if (!crud?.error && crud.data.success_status) {
            if(FromCart){
                handleSuccessMessage('Wishlist Created','diff')
            }else{
                handleSuccessMessage(crud,message,'diff')

            }
        } else {
            handleErrorMessage(crud.message.response.data.message)
        }
    }
    const findIndex = (item)=>selected.map((val)=>val.collection_id).indexOf(item.collection_id) > -1;
    const LoaderSkeleton =()=>(
        <div className="px-4 pt-[22px]" style={{height:'200px',overFlow:'auto'}}>
            {[...Array(3)].map((item,i)=>(
                <div className={`w-full bg-[#F5F5FA] border-[#F5F5FA] rounded-[7px] h-[42px] flex ${i!==0 ? 'mt-1':''}`} key={i}>
                    <div className="flex justify-between items-center px-4 w-full" >
                        <div className="flex w-full items-center ">
                            {/* <img src="images/Iconawesome-heart.png" alt="icon" className="h-3 w-[14px]" /> */}
                            <ShimmerBadge width={"300"}/>
                        </div>
                        <div className="relative checkbox custom-checkbox custom-checkbox2 flex">
                            <ShimmerCircularImage size={10}/>
                            <label htmlFor="checkbox-s1" className="text-lg font-normal  text-[#555259] pl-2"></label>
                        </div>
                    </div>
                </div>
            ))}

        </div>
    )
    return (
        <Modal isOpen={show!==''}>
            <div className="modal-dialog modal-dialog-centered relative sm:max-w-[430px] w-full pointer-events-none mx-auto px-4" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Wishlist(s)
                        </h5>
                        <button type="button"
                            onClick={()=>setmodalType('')}
                            className="btn-close2 box-content sm:w-4 sm:h-4 w-3 h-3 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute sm:top-[22px] sm:right-5 top-4 right-4"
                            data-bs-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    {loading? <LoaderSkeleton/>:<div className="px-4 pt-[22px]" style={{height:'200px',overflow:'auto'}}>
                        {list.length>0 && list.map((item,i)=>(
                            <div className={`w-full bg-[#F5F5FA] border-[#F5F5FA] rounded-[7px] h-[42px] flex ${i!==0 ? 'mt-1':''}`} key={item.collection_id}>
                                <div className="flex justify-between items-center px-4 w-full" >
                                    <div className="flex w-full items-center ">
                                        <img src="/images/Iconawesome-heart.png" alt="icon" className="h-3 w-[14px]" />
                                        <p className="text-[#090406] text-sm font-normal pl-6">{item.collection_name.length > 45 ? `${item.collection_name.slice(0,45)}...`:`${item.collection_name}`}</p>
                                    </div>
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 flex">
                                        <Checkbox
                                            icon={
                                                <Check.GoCheck color="black" size={14} style={{background:`${findIndex(item) ? '':''}`}} />
                                            }
                                            name="my-input"
                                            className="cursor-pointer"
                                            checked={findIndex(item)}
                                            onChange={(value, event) => {
                                                event.preventDefault()
                                                handleSelect(item)
                                            }}
                                            borderColor={`${findIndex(item)?"#B8C5DC":"#555259"}`}
                                            style={{ cursor: "pointer", border:`1px solid ${findIndex(item)?"#555259":"#B8C5DC"}` }}
                                            labelStyle={{ marginLeft: 5, userSelect: "none" ,cursor:'pointer'}}
                                        /> 
                                        <label htmlFor="checkbox-s1" className="text-lg font-normal  text-[#555259] pl-2"></label>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>}
                    <p className="text-end mx-4 mt-4 cursor-pointer text-[#000000] font-semibold text-xs" data-bs-toggle="modal" data-bs-target="#updatewishlist" onClick={()=>{
                        setisCreate(true)
                    }}>+ Create New Wishlist</p>
                    <div
                        className="modal-footer flex flex-shrink-0 flex-wrap items-center p-4 border-gray-200 rounded-b-md">
                        <button
                            onClick={()=>{
                                if(!PreveiouslyExist && selected.length===0){
                                    setmodalType('')
                                    return;
                                }
                                handleAddToWishList(selected)
                            }}
                            type="button" className="w-full px-6 py-2.5 bg-[#555259] text-white font-semibold text-sm leading-tight rounded-lg shadow-md transition duration-150 ease-in-out ml-1 to-wishlist flex justify-center items-center" data-bs-dismiss="modal" aria-label="Close">
                            {wishlistLoader?<ThreeDotsLoader/>:`${PreveiouslyExist? 'Update': 'Add'} to Wishlist(s)`}
                        </button>
                    </div>
                </div>
            </div>
            <CreateModal
                handleCreate={handleCreate}
                setmodalType={setmodalType}
                type="create"
                isCreate={isCreate}
                setisCreate={setisCreate}
            />
        </Modal>
    )
}
